import { useState, useEffect } from "react";

export function Countdown({ days, urgence, actionLabel }) {
  const [remaining, setRemaining] = useState(days * 86400);
  useEffect(() => { setRemaining(days * 86400); }, [days]);
  useEffect(() => {
    const t = setInterval(() => setRemaining((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, []);

  const d = Math.floor(remaining / 86400);
  const h = Math.floor((remaining % 86400) / 3600);
  const m = Math.floor((remaining % 3600) / 60);
  const s = remaining % 60;
  const color = urgence === "critique" ? "#EF4444" : urgence === "haute" ? "#F59E0B" : "#10B981";

  return (
    <div className="flex items-center justify-between py-3 border-b border-slate-100 last:border-0" data-testid="countdown-row">
      <div>
        <div className="font-heading font-bold text-[#1E293B]">{actionLabel}</div>
        <div className="text-xs uppercase tracking-widest" style={{ color }}>{urgence}</div>
      </div>
      <div className="flex items-baseline gap-2 font-heading font-black tabular-nums" style={{ color }}>
        <Block label="j" val={d} /><Block label="h" val={h} /><Block label="m" val={m} /><Block label="s" val={s} small />
      </div>
    </div>
  );
}

function Block({ val, label, small }) {
  return (
    <div className="flex flex-col items-center">
      <span className={small ? "text-xl" : "text-3xl"}>{String(val).padStart(2, "0")}</span>
      <span className="text-[0.55rem] tracking-widest text-slate-400 uppercase">{label}</span>
    </div>
  );
}
